/**
 * ss-collection-facets.js — filter panel toggle (event delegation survives AJAX swaps)
 */
(function () {
  'use strict';

  var rootsBound = new WeakSet();

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function getPanelParts(root) {
    return {
      openBtn: root.querySelector('[data-ss-facets-open]'),
      panel: root.querySelector('[data-ss-facets-panel]'),
      backdrop: root.querySelector('.ss-facets__backdrop')
    };
  }

  function setOpen(root, open) {
    var parts = getPanelParts(root);
    var panel = parts.panel;
    var backdrop = parts.backdrop;
    var openBtn = parts.openBtn;
    if (!panel) return;

    if (isDesktop()) {
      panel.hidden = false;
      if (backdrop) backdrop.hidden = true;
      document.body.classList.remove('ss-facets-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      return;
    }

    panel.hidden = !open;
    if (backdrop) backdrop.hidden = !open;
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('ss-facets-open', open);
    if (open) {
      var first = panel.querySelector('input:not([type="hidden"]), select, summary');
      if (first) first.focus();
    }
  }

  function syncLayout(root) {
    var parts = getPanelParts(root);
    if (!parts.panel) return;

    if (isDesktop()) {
      parts.panel.hidden = false;
      if (parts.backdrop) parts.backdrop.hidden = true;
      if (parts.openBtn) parts.openBtn.setAttribute('aria-expanded', 'true');
      return;
    }

    if (!document.body.classList.contains('ss-facets-open')) {
      parts.panel.hidden = true;
      if (parts.backdrop) parts.backdrop.hidden = true;
      if (parts.openBtn) parts.openBtn.setAttribute('aria-expanded', 'false');
    }
  }

  function bindAccordions(root) {
    var groups = root.querySelectorAll('.ss-facets__group');
    if (!groups.length) return;

    var openCount = 0;
    var firstOpen = null;
    groups.forEach(function (group) {
      if (group.open) {
        openCount += 1;
        if (!firstOpen) firstOpen = group;
      }
    });
    if (openCount > 1 && firstOpen) {
      groups.forEach(function (group) {
        if (group !== firstOpen) group.open = false;
      });
    }

    groups.forEach(function (group) {
      if (group.dataset.ssAccordionBound) return;
      group.dataset.ssAccordionBound = '1';

      group.addEventListener('toggle', function () {
        if (!group.open) return;
        groups.forEach(function (other) {
          if (other !== group) other.open = false;
        });
      });
    });
  }

  function init(root) {
    if (rootsBound.has(root)) return;
    rootsBound.add(root);

    syncLayout(root);

    root.addEventListener('click', function (e) {
      var parts = getPanelParts(root);
      if (!parts.panel) return;

      if (e.target.closest('[data-ss-facets-open]')) {
        e.preventDefault();
        setOpen(root, parts.panel.hidden);
        return;
      }

      if (e.target.closest('.ss-facets__foot-apply')) {
        e.preventDefault();
        var form = root.querySelector('form');
        if (form && typeof window.ssFacetsFetch === 'function') {
          window.ssFacetsFetch(form);
        }
        setOpen(root, false);
        if (parts.openBtn) parts.openBtn.focus();
        return;
      }

      if (e.target.closest('[data-ss-facets-close]')) {
        e.preventDefault();
        setOpen(root, false);
        if (parts.openBtn) parts.openBtn.focus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var parts = getPanelParts(root);
      if (!parts.panel || parts.panel.hidden || isDesktop()) return;
      setOpen(root, false);
      if (parts.openBtn) parts.openBtn.focus();
    });

    bindAccordions(root);
  }

  function syncAll() {
    document.querySelectorAll('[data-ss-facets]').forEach(syncLayout);
  }

  if (!window._ssFacetsResizeBound) {
    window._ssFacetsResizeBound = true;
    window.addEventListener('resize', syncAll);
  }

  window.ssFacetsRebind = function (root) {
    syncLayout(root);
    bindAccordions(root);
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ss-facets]').forEach(init);
  });
})();
